module.exports = __webpack_public_path__ + "img/page-ico.2fa487e7.png";